export enum ThreadStatus {
  'new' = 'new',
  'recent' = 'recent',
  'read' = 'read',
}
